<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 100 100"
    x="0px"
    y="0px"
  >
    <title>Essential Icons</title>
    <path d="M80,28H20a3,3,0,0,1,0-6H80a3,3,0,0,1,0,6Z"></path>
    <path d="M80,53H20a3,3,0,0,1,0-6H80a3,3,0,0,1,0,6Z"></path>
    <path d="M80,78H20a3,3,0,0,1,0-6H80a3,3,0,0,1,0,6Z"></path>
  </svg>
</template>

<script>
export default {
  name: "Menu",
};
</script>
